export function shareLink(data) {
    if (navigator.canShare) {
        navigator.share(data)
            .then(() => console.log('Share was successful.'))
            .catch((error) => console.log('Sharing failed', error));
    } else {
        console.log(`Your system doesn't support sharing files.`);
    }
}